<template>
  <div class="py-28 text-center">
    <UiNarrowContainer>
      <UiHeading type="h4" class="mb-4 text-primary-400">{{ content.subtitle }}</UiHeading>
      <UiHeading type="h1" class="mb-8">{{ content.title }}</UiHeading>
      <UiSlider v-if="isMobile" id="page-popular-categories">
        <PagePopularCategory v-for="item in content.categories" :key="item.id" :item="item" class="w-3/5 shrink-0" />
      </UiSlider>
      <div v-else class="flex w-full flex-col justify-center gap-4 md:flex-row">
        <PagePopularCategory v-for="item in content.categories" :key="item.id" :item="item" />
      </div>
    </UiNarrowContainer>
  </div>
</template>

<script setup lang="ts">
import type { PagePopularCategoriesProps } from '~/components/Page/types';

const { isMobile } = useBreakpoints();

defineProps<PagePopularCategoriesProps>();
</script>
